export const ObjectFilter = (obj, predicate) =>
    Object.fromEntries(Object.entries(obj).filter(predicate));
